import axiosInstance from '@/axiosInstance'
import User from '@/structs/User'

const actions = {
  fetchUserApps ({ commit }, { userid = null }) {
    return new Promise((resolve, reject) => {
      return axiosInstance.get(
        process.env.BASE_URL + 'api/?mode=APPS&action=LOAD&userapps=true' + (userid ? '&userid=' + userid : '')
      ).then(response => {
        if (response.data.apps && response.data.apps.length > 0) {
          resolve(response.data.apps)
        } else {
          resolve([])
        }
      }).catch((err) => { console.log(err) && reject(err) })
    })
  },
  createUser ({ commit }, { user }) {
    return new Promise((resolve, reject) => {
      if (!user || !(user instanceof User)) {
        reject(Error(`Invalid user - ${user}`))
        return
      }

      // should be POST
      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=CREATE',
        user
      ).then(response => {
        const user = Object.assign(new User(), response.data)

        resolve(user)
      }).catch((err) => { reject(err) })
    })
  },
  updateUser ({ commit }, { user, password }) {
    return new Promise((resolve, reject) => {
      if (!user || !(user instanceof User)) {
        reject(Error(`Invalid user - ${user}`))
        return
      }

      // should be POST
      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=UPDATE',
        { user: user, password: password }
      ).then(response => {
        const user = Object.assign(new User(), response.data.user)

        // commit to the auth store
        commit('auth/SET_AUTH_USER', user, { root: true })
        resolve(user)
      }).catch((err) => { reject(err) })
    })
  },
  removeUser ({ commit }, { userid }) {
    return new Promise((resolve, reject) => {
      const data = {
        userid: userid
      }

      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=REMOVE',
        data
      ).then(response => {
        resolve({
          userid: response.data.userid
        })
      }).catch((err) => { reject(err) })
    })
  },
  removeGroups ({ commit }, { userid, groupnames }) {
    return new Promise((resolve, reject) => {
      if (typeof (groupnames) === 'string') {
        groupnames = [groupnames]
      }

      const data = {
        userid: userid,
        groupnames: groupnames
      }

      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=REMOVEGROUPS',
        data
      ).then(response => {
        resolve({
          userid: response.data.userid,
          groupnames: response.data.groupnames
        })
      }).catch((err) => { reject(err) })
    })
  },
  addGroups ({ commit }, { userid, groupnames }) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(groupnames)) {
        groupnames = [groupnames]
      }

      const data = {
        userid: userid,
        groupnames: groupnames
      }

      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=ADDGROUPS',
        data
      ).then(response => {
        resolve({
          userid: response.data.userid,
          groupnames: response.data.groupnames
        })
      }).catch((err) => { reject(err) })
    })
  },
  addUserApps ({ commit }, { userid, appids }) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(appids)) {
        appids = [appids]
      }

      const data = {
        userid: userid,
        appids: appids
      }

      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=ADDAPPS',
        data
      ).then(response => {
        resolve({
          userid: response.data.userid,
          appids: response.data.appids
        })
      }).catch((err) => { reject(err) })
    })
  },
  removeUserApps ({ commit }, { userid, appids }) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(appids)) {
        appids = [appids]
      }

      const data = {
        userid: userid,
        appids: appids
      }

      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=USER&action=REMOVEAPPS',
        data
      ).then(response => {
        resolve({
          userid: response.data.userid,
          appids: response.data.appids
        })
      }).catch((err) => { reject(err) })
    })
  }
}

export default {
  namespaced: true,
  actions
}
